/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TransferInventoryDetModel { 
    transferInventoryDetId?: number;
    transferInventoryId?: number;
    ordinal?: number;
    itemNumber?: string | null;
    itemDescription?: string | null;
    uOfM?: string | null;
    units?: number | null;
    quantity?: number;
    unitPrice?: number | null;
    amount?: number | null;
    reference?: string | null;
    uniqueIdentifierType?: number | null;
    uniqueIdentifier?: string | null;
    batchIdentifierType?: number | null;
    batchIdentifier?: string | null;
    sellByDate?: string | null;
    barcodeSource?: string | null;
    timeStamp?: string;
    statusId?: number;
    gtinFormat?: string | null;
    readonly uniqueIdentifierTypeDisplay?: string | null;
    readonly batchIdentifierTypeDisplay?: string | null;
    validateItemIdentifier?: boolean | null;
    weightType?: string | null;
}

